<button type="button" #tabElement class="tab" (click)="moveHighlighter(i)" [class.active]="activeIndex === i" *ngFor="let tab of tabs; let i = index">{{ tab }}</button>
<div class="tab-highlighter" #highlighter></div>